exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-listing-state-popover {\n.popover-body {\n    height: 300px !important;\n    overflow-y: auto !important;\n}\n}\n", ""]);

// exports
